import * as actionTypes from '../actions/actionTypes';

export const snackbarChanged =  (myParam) => {
    return {type: actionTypes.SNACKBAR_CHANGED, payload: myParam};
}